window.BloomRailPresentation = Object.freeze({
  "mocha": {
    "color": "#695046",
    "tilt": -1.1,
    "offset": 0
  },
  "burgundy": {
    "color": "#733c46",
    "tilt": 0.8,
    "offset": 9
  },
  "sand": {
    "color": "#c7b69b",
    "tilt": -0.6,
    "offset": -5
  },
  "camel": {
    "color": "#ad7d53",
    "tilt": 0.5,
    "offset": 5
  },
  "mist": {
    "color": "#a7a6a1",
    "tilt": -0.9,
    "offset": -2
  },
  "mocha-croco": {
    "color": "#442a23",
    "tilt": 0.5,
    "offset": 0,
    "collectionLabel": "MOCHA CROCO"
  },
  "burgundy-croco": {
    "color": "#641e2c",
    "tilt": -0.5,
    "offset": 0,
    "collectionLabel": "BURGUNDY CROCO"
  }
});
